import React from 'react';
import { Link } from 'react-router-dom';
import './Tuotantopalvelut.css';
import './Tuotannot.css'; // Re-using styles from Tuotannot

const services = [
  { headline: 'Äänittäminen', slug: 'aanittaminen' },
  { headline: 'Äänisuunnittelu', slug: 'aanisuunnittelu' },
  { headline: 'Voice over', slug: 'voice-over' },
  { headline: 'Radiomainokset', slug: 'radiomainokset' },
  { headline: 'Tuotantopäällikkö', slug: 'tuotantopaallikko' },
];

const Tuotantopalvelut = () => {
  return (
    <div className="tuotantopalvelut-container">
      <p>Remena tarjoaa korkeatasoisia tuotantopalveluja äänittämisessä, elokuvaamisessa ja tuottamisessa. Kokemusta on yli kahdenkymmenen vuoden ajalta ja takana noin 700 tuotantoa elokuvista mainoksiin ja radioäänitöihin. Myös tapahtumatuotannoista, bändihommista, livemiksaamisesta ja monikameratuotannoista on kokemusta useiden vuosien ajalta.</p>
      <div className="tuotannot-grid" style={{ marginTop: '3rem' }}>
        {services.map((service) => (
          <Link
            key={service.slug}
            to={`/tuotantopalvelut/${service.slug}`}
            className="production-card taller-card"
          >
            <h3>{service.headline}</h3>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Tuotantopalvelut;